import { CreateExpenseDtoTypeEnum } from 'src/Services/API/generated';

export enum MainCategory {
  FixedCosts = 'FIXED_COSTS',
  DailyLife = 'DAILY_LIFE',
  WorksEquipment = 'WORKS_EQUIPMENT',
  FundingCalls = 'FUNDING_CALLS',
  RentalHousing = 'RENTAL_HOUSING',
  EventsTourism = 'EVENTS_TOURISM',
  EstateLands = 'ESTATE_LANDS',
  Operating = 'OPERATING',
  Subsidies = 'SUBSIDIES',
  Reimbursements = 'REIMBURSEMENTS',
}

export enum SubCategory {
  TaxesAndDuties = 'TAXES_AND_DUTIES',
  EnergyAndWater = 'ENERGY_AND_WATER',
  InsuranceAndAdmin = 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions = 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees = 'CONDO_FEES',
  Groceries = 'GROCERIES',
  CleaningAndLaundry = 'CLEANING_AND_LAUNDRY',
  Consumables = 'CONSUMABLES',
  Leisure = 'LEISURE',
  Garden = 'GARDEN',
  MajorWorks = 'MAJOR_WORKS',
  Repairs = 'REPAIRS',
  FurnitureDecor = 'FURNITURE_DECOR',
  Equipment = 'EQUIPMENT',
  RegularTransfers = 'REGULAR_TRANSFERS',
  ExceptionalOperations = 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms = 'ONLINE_PLATFORMS',
  DirectPrivateCircle = 'DIRECT_PRIVATE_CIRCLE',
  Privatization = 'PRIVATIZATION',
  PublicReception = 'PUBLIC_RECEPTION',
  LeasesAndRentals = 'LEASES_AND_RENTALS',
  DirectOperation = 'DIRECT_OPERATION',
  AdditionalActivities = 'ADDITIONAL_ACTIVITIES',
  PublicFunds = 'PUBLIC_FUNDS',
  PrivateFunds = 'PRIVATE_FUNDS',
  InternalTribe = 'INTERNAL_TRIBE',
  ExternalThirdParty = 'EXTERNAL_THIRD_PARTY',
}

interface ExpenseTypeMeta {
  main: MainCategory;
  sub: SubCategory;
  isIncome: boolean;
}

export const EXPENSE_TYPE_TREE: Record<CreateExpenseDtoTypeEnum, ExpenseTypeMeta> = {
  HOUSING_TAX: { main: MainCategory.FixedCosts, sub: SubCategory.TaxesAndDuties, isIncome: false },
  PROPERTY_TAX: { main: MainCategory.FixedCosts, sub: SubCategory.TaxesAndDuties, isIncome: false },
  WASTE_COLLECTION_TAX: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.TaxesAndDuties,
    isIncome: false,
  },
  OTHER_TAX: { main: MainCategory.FixedCosts, sub: SubCategory.TaxesAndDuties, isIncome: false },

  ELECTRICITY: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  WATER: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  GAS: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  HEATING_OIL: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  WOOD: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  WOOD_PELLETS: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },
  OTHER_ENERGY: { main: MainCategory.FixedCosts, sub: SubCategory.EnergyAndWater, isIncome: false },

  HOME_INSURANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.InsuranceAndAdmin,
    isIncome: false,
  },
  OTHER_INSURANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.InsuranceAndAdmin,
    isIncome: false,
  },
  BANK_FEES: { main: MainCategory.FixedCosts, sub: SubCategory.InsuranceAndAdmin, isIncome: false },
  LEGAL_PROTECTION: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.InsuranceAndAdmin,
    isIncome: false,
  },
  MANAGEMENT_TRAVEL: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.InsuranceAndAdmin,
    isIncome: false,
  },
  OTHER_INSURANCE_AND_ADMIN: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.InsuranceAndAdmin,
    isIncome: false,
  },

  INTERNET_AND_PHONE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  TV: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  ALARM: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  BOILER_MAINTENANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  CHIMNEY_SWEEPING: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  GARDEN_MAINTENANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  POOL_MAINTENANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  TENNIS_MAINTENANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },
  OTHER_CONTRACT: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.ContractsAndSubscriptions,
    isIncome: false,
  },

  SYNDIC_FUND_CALLS: { main: MainCategory.FixedCosts, sub: SubCategory.CondoFees, isIncome: false },
  COMMON_AREAS_MAINTENANCE: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.CondoFees,
    isIncome: false,
  },
  OTHER_CONDO_CHARGES: {
    main: MainCategory.FixedCosts,
    sub: SubCategory.CondoFees,
    isIncome: false,
  },

  SUPERMARKET: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },
  MARKET: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },
  CATERING: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },
  BEVERAGES: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },
  GROCERIES_CLEANING_PRODUCTS: {
    main: MainCategory.DailyLife,
    sub: SubCategory.Groceries,
    isIncome: false,
  },
  HOUSE_FUND: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },
  OTHER_GROCERIES: { main: MainCategory.DailyLife, sub: SubCategory.Groceries, isIncome: false },

  HOUSEHOLD_CLEANING_PRODUCTS: {
    main: MainCategory.DailyLife,
    sub: SubCategory.CleaningAndLaundry,
    isIncome: false,
  },
  DRY_CLEANING: {
    main: MainCategory.DailyLife,
    sub: SubCategory.CleaningAndLaundry,
    isIncome: false,
  },
  LAUNDRY: { main: MainCategory.DailyLife, sub: SubCategory.CleaningAndLaundry, isIncome: false },
  CLEANING_LADY: {
    main: MainCategory.DailyLife,
    sub: SubCategory.CleaningAndLaundry,
    isIncome: false,
  },
  OTHER_CLEANING_LAUNDRY: {
    main: MainCategory.DailyLife,
    sub: SubCategory.CleaningAndLaundry,
    isIncome: false,
  },

  LIGHT_BULBS_BATTERIES: {
    main: MainCategory.DailyLife,
    sub: SubCategory.Consumables,
    isIncome: false,
  },
  TOILET_PAPER: { main: MainCategory.DailyLife, sub: SubCategory.Consumables, isIncome: false },
  BBQ_CHARCOAL: { main: MainCategory.DailyLife, sub: SubCategory.Consumables, isIncome: false },
  LAWN_MOWER_FUEL: { main: MainCategory.DailyLife, sub: SubCategory.Consumables, isIncome: false },
  OTHER_CONSUMABLES: {
    main: MainCategory.DailyLife,
    sub: SubCategory.Consumables,
    isIncome: false,
  },

  BOARD_GAMES: { main: MainCategory.DailyLife, sub: SubCategory.Leisure, isIncome: false },
  BIKES: { main: MainCategory.DailyLife, sub: SubCategory.Leisure, isIncome: false },
  RACKETS_AND_BALLS: { main: MainCategory.DailyLife, sub: SubCategory.Leisure, isIncome: false },
  OTHER_LEISURE: { main: MainCategory.DailyLife, sub: SubCategory.Leisure, isIncome: false },

  PLANTS: { main: MainCategory.DailyLife, sub: SubCategory.Garden, isIncome: false },
  OCCASIONAL_GARDENER: { main: MainCategory.DailyLife, sub: SubCategory.Garden, isIncome: false },
  FERTILIZERS_HERBICIDES: {
    main: MainCategory.DailyLife,
    sub: SubCategory.Garden,
    isIncome: false,
  },
  GARDEN_TOOLS_DAILY: { main: MainCategory.DailyLife, sub: SubCategory.Garden, isIncome: false },
  OTHER_GARDEN: { main: MainCategory.DailyLife, sub: SubCategory.Garden, isIncome: false },

  ROOFING: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  FACADE_RENOVATION: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  INSULATION: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  DOORS_WINDOWS: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  WOODWORK: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  MASONRY: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  PLUMBING_NETWORK: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  ELECTRICAL_NETWORK: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  HEATING_AND_AC: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  EARTHWORK: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  SANITATION: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  LANDSCAPING: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  POOL_LINER: { main: MainCategory.WorksEquipment, sub: SubCategory.MajorWorks, isIncome: false },
  POOL_FILTRATION: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  TENNIS_SURFACE: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },
  OTHER_MAJOR_WORKS: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.MajorWorks,
    isIncome: false,
  },

  PLUMBER_REPAIR: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },
  ELECTRICIAN_REPAIR: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.Repairs,
    isIncome: false,
  },
  LOCKSMITH: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },
  GARDENER_REPAIR: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },
  POOL_TECHNICIAN: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },
  MECHANIC: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },
  OTHER_REPAIR: { main: MainCategory.WorksEquipment, sub: SubCategory.Repairs, isIncome: false },

  SOFAS_BEDS: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.FurnitureDecor,
    isIncome: false,
  },
  APPLIANCES: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.FurnitureDecor,
    isIncome: false,
  },
  DISHWARE: { main: MainCategory.WorksEquipment, sub: SubCategory.FurnitureDecor, isIncome: false },
  DECORATION: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.FurnitureDecor,
    isIncome: false,
  },
  LINENS: { main: MainCategory.WorksEquipment, sub: SubCategory.FurnitureDecor, isIncome: false },

  TV_HIFI: { main: MainCategory.WorksEquipment, sub: SubCategory.Equipment, isIncome: false },
  GARDEN_TOOLS_EQUIPMENT: {
    main: MainCategory.WorksEquipment,
    sub: SubCategory.Equipment,
    isIncome: false,
  },
  HOUSE_TOOLS: { main: MainCategory.WorksEquipment, sub: SubCategory.Equipment, isIncome: false },

  MONTHLY_TRANSFER: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.RegularTransfers,
    isIncome: true,
  },
  QUARTERLY_TRANSFER: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.RegularTransfers,
    isIncome: true,
  },
  SEMI_ANNUAL_TRANSFER: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.RegularTransfers,
    isIncome: true,
  },
  ANNUAL_TRANSFER: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.RegularTransfers,
    isIncome: true,
  },

  PERIOD_END_ADJUSTMENT: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.ExceptionalOperations,
    isIncome: true,
  },
  EXCEPTIONAL_WORK_CONTRIBUTION: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.ExceptionalOperations,
    isIncome: true,
  },
  ACCOUNT_REPLENISHMENT: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.ExceptionalOperations,
    isIncome: true,
  },
  OTHER_FUND_CALL: {
    main: MainCategory.FundingCalls,
    sub: SubCategory.ExceptionalOperations,
    isIncome: true,
  },

  AIRBNB_AGENCY: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.OnlinePlatforms,
    isIncome: true,
  },
  AIRBNB_DIRECT: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.OnlinePlatforms,
    isIncome: true,
  },
  BOOKING: { main: MainCategory.RentalHousing, sub: SubCategory.OnlinePlatforms, isIncome: true },
  GENS_DE_CONFIANCE: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.OnlinePlatforms,
    isIncome: true,
  },
  OTHER_ONLINE_RENTAL: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.OnlinePlatforms,
    isIncome: true,
  },

  BED_AND_BREAKFAST: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.DirectPrivateCircle,
    isIncome: true,
  },
  FRIENDS_ACQUAINTANCES: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.DirectPrivateCircle,
    isIncome: true,
  },
  INTERNAL_FAMILY_RENT: {
    main: MainCategory.RentalHousing,
    sub: SubCategory.DirectPrivateCircle,
    isIncome: true,
  },

  WEDDINGS_RECEPTIONS: {
    main: MainCategory.EventsTourism,
    sub: SubCategory.Privatization,
    isIncome: true,
  },
  SEMINAR_RENTAL: {
    main: MainCategory.EventsTourism,
    sub: SubCategory.Privatization,
    isIncome: true,
  },
  CINEMA_PHOTO_RENTAL: {
    main: MainCategory.EventsTourism,
    sub: SubCategory.Privatization,
    isIncome: true,
  },

  VISITS_TICKETING: {
    main: MainCategory.EventsTourism,
    sub: SubCategory.PublicReception,
    isIncome: true,
  },
  SHOP_SOUVENIRS: {
    main: MainCategory.EventsTourism,
    sub: SubCategory.PublicReception,
    isIncome: true,
  },

  HUNTING_LEASE: {
    main: MainCategory.EstateLands,
    sub: SubCategory.LeasesAndRentals,
    isIncome: true,
  },
  FISHING_LEASE: {
    main: MainCategory.EstateLands,
    sub: SubCategory.LeasesAndRentals,
    isIncome: true,
  },
  AGRICULTURAL_LEASE: {
    main: MainCategory.EstateLands,
    sub: SubCategory.LeasesAndRentals,
    isIncome: true,
  },

  HAY_GRAIN_SALE: {
    main: MainCategory.EstateLands,
    sub: SubCategory.DirectOperation,
    isIncome: true,
  },
  WOOD_SALE: { main: MainCategory.EstateLands, sub: SubCategory.DirectOperation, isIncome: true },

  WINTER_STORAGE: {
    main: MainCategory.Operating,
    sub: SubCategory.AdditionalActivities,
    isIncome: true,
  },
  ELECTRICITY_RESALE: {
    main: MainCategory.Operating,
    sub: SubCategory.AdditionalActivities,
    isIncome: true,
  },

  ANAH_RENOV_AID: { main: MainCategory.Subsidies, sub: SubCategory.PublicFunds, isIncome: true },
  DRAC_SUBSIDY: { main: MainCategory.Subsidies, sub: SubCategory.PublicFunds, isIncome: true },
  PATRONAGE_CROWDFUNDING: {
    main: MainCategory.Subsidies,
    sub: SubCategory.PrivateFunds,
    isIncome: true,
  },

  TRIBE_FEES_SHARING: {
    main: MainCategory.Reimbursements,
    sub: SubCategory.InternalTribe,
    isIncome: true,
  },
  INSURANCE_CLAIM_REIMBURSEMENT: {
    main: MainCategory.Reimbursements,
    sub: SubCategory.ExternalThirdParty,
    isIncome: true,
  },
  TAX_OVERPAYMENT: {
    main: MainCategory.Reimbursements,
    sub: SubCategory.ExternalThirdParty,
    isIncome: true,
  },
  OTHER_REIMBURSEMENT: {
    main: MainCategory.Reimbursements,
    sub: SubCategory.ExternalThirdParty,
    isIncome: true,
  },
};

export const ALL_EXPENSE_TYPES = Object.keys(EXPENSE_TYPE_TREE) as CreateExpenseDtoTypeEnum[];
